export const route = {
    patterns: {
        imprint: '/imprint',
    },
};
